import styled from "styled-components";

import { Autocomplete } from "@mui/material";
import color from "../../constants/color";
import materialUI from "../../material-UI";

interface AutocompleteI {
  borderRadius?: string;
}

export const AutoCompleteCustom = styled(Autocomplete)<AutocompleteI>`
  border-radius: ${(props) => props.borderRadius || ""};
  & .MuiOutlinedInput-root {
    border-radius: ${(props) => props.borderRadius || ""};
  }
`;

export const Text = styled(materialUI.TextField)``;
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const Helper = styled.small`
  font-size: 12px;
  color: red;
  font-family: Inter;
  margin-left: 12px;
  margin-top: 4px;
`;
interface LabelProps {
  color: string;
}
export const Label = styled.label<LabelProps>`
  font-size: 14px;
  font-family: Inter;
  margin-bottom: 8px;
  color: ${(props) => props.color || color.grey1};
`;
